export const BRAND_DELETE_RESET = 'BRAND_DELETE_RESET'
export const BRAND_DELETE_SET_ERROR = 'BRAND_DELETE_SET_ERROR'
export const BRAND_DELETE_SET_DELETED = 'BRAND_DELETE_SET_DELETED'
export const BRAND_DELETE_TOGGLE_LOADING = 'BRAND_DELETE_TOGGLE_LOADING'
